"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./css/cMultiToggle.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactMultiToggleExtra = _interopRequireDefault(require("react-multi-toggle-extra"));
var _styles = require("@mui/material/styles");
const _excluded = ["className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const StyledMultiToggle = (0, _styles.styled)(_reactMultiToggleExtra.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    fontSize: theme.typography.fontSize
  };
});

/**
 * マルチトグル部品
 * @prop {array} options - 選択肢の一覧
 * @prop {string} options.displayName - 表示名
 * @prop {string} options.value - 値
 * @prop {string} selectedOption - 選択されている値
 * @prop {func} onSelectOption - 選択時のイベント<br/>
 * シグネチャ：()
 */
const CMultiToggle = function (props) {
  const {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(StyledMultiToggle, _extends({}, rest, {
    className: className
  }));
};
CMultiToggle.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    displayName: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  selectedOption: _propTypes.default.string,
  onSelectOption: _propTypes.default.func
};
var _default = exports.default = CMultiToggle;